import type { FC } from 'react';

import { Box, CircularProgress } from '@mui/material';

interface AppCircularProgressProps {
  loading?: boolean;
}

export const AppCircularProgress: FC<AppCircularProgressProps> = ({ loading }) => {
  return (
    <>
      {loading && (
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            position: 'fixed',
            overflow: 'hidden',
            flexDirection: 'column',
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            left: 0,
            top: 0
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};
